import { useState } from 'react'
import { Relance, parseRelances } from '../Types/Interface/Relance'

export interface UseRelancesManagementReturn {
    relances: Relance[]
    newRelance: Relance
    setNewRelance: (relance: Relance) => void
    handleAddRelance: () => void
    handleDeleteRelance: (index: number) => void
    getRelanceLabel: (relance: Relance) => string
    resetRelances: () => void
    loadRelances: (relancesStr?: string) => void
}

export function useRelancesManagement(
    setHasChanges: (value: boolean) => void
): UseRelancesManagementReturn {
    const [relances, setRelances] = useState<Relance[]>([])
    const [newRelance, setNewRelance] = useState<Relance>({ value: 1, unit: 'd' })

    const handleAddRelance = () => {
        if (newRelance.value > 0) {
            setRelances([...relances, { ...newRelance }])
            setNewRelance({ value: 1, unit: 'd' })
            setHasChanges(true)
        }
    }

    const handleDeleteRelance = (index: number) => {
        setRelances(relances.filter((_, i) => i !== index))
        setHasChanges(true)
    }

    const getRelanceLabel = (relance: Relance) => {
        const unitLabels = { d: 'jour', w: 'semaine', m: 'mois' }
        const unit = unitLabels[relance.unit]
        return `${relance.value} ${unit}${relance.value > 1 ? 's' : ''}`
    }

    const resetRelances = () => {
        setRelances([])
        setNewRelance({ value: 1, unit: 'd' })
    }

    const loadRelances = (relancesStr?: string) => {
        const relancesData = parseRelances(relancesStr)
        setRelances(relancesData)
    }

    return {
        relances,
        newRelance,
        setNewRelance,
        handleAddRelance,
        handleDeleteRelance,
        getRelanceLabel,
        resetRelances,
        loadRelances,
    }
}
